import { ApolloError } from "@apollo/client";
import { PlusIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../UI/IconButton.tsx";
import { useToast } from "../../UI/Feedback/useToast.ts";
import { useAllUserGroups } from "../../UserGroup/useAllUserGroups.ts";
import { onboardingLivePlanPathOf } from "../OnboardingLivePaths.ts";
import { useCreateOnboardingLiveCreationIntent } from "../useCreateOnboardingLiveCreationIntent.ts";
import { useOpenFromOnboardingLivesList } from "./onboardingLivesListNavigation.ts";

export function NewOnboardingLivePlanButton() {
  const { userGroups } = useAllUserGroups();
  const { createIntent, creating } = useCreateOnboardingLiveCreationIntent();
  const openFromList = useOpenFromOnboardingLivesList();
  const showToast = useToast();
  const userGroupsWithOnboardingLive = userGroups.filter(
    (g) => g.onboardingLiveRequired,
  );
  const defaultUserGroup =
    userGroupsWithOnboardingLive.find((g) => g.id === "adults") ??
    userGroupsWithOnboardingLive[0];

  async function createPlan() {
    if (creating) return;
    if (!defaultUserGroup) {
      showToast(
        "Nessuno user group prevede le live onboarding: abilitale dalla pagina User Groups",
        "error",
      );
      return;
    }
    try {
      const intentId = await createIntent(defaultUserGroup.id);
      openFromList(onboardingLivePlanPathOf(intentId));
    } catch (e) {
      showToast((e as ApolloError)?.message ?? "Errore", "error");
    }
  }

  return (
    <IconButton
      label={"Nuova pianificazione"}
      icon={PlusIcon}
      onClick={createPlan}
    />
  );
}
